<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    transition="fade-transition"
    :scrollable="true"
  >
    <v-card>
      <v-card-title class="headline">{{ $t("userCountryDialog.title") }}</v-card-title>
      <v-card-text>
        <div class="pb-2">
          <span>{{$t("userCountryDialog.description")}}</span>
        </div>
        <country-select :disabled="loading" v-model="countryId"></country-select>    
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" class="primary" text @click="save()">
          <v-icon left>mdi-content-save</v-icon>{{ $t("common.save") }}
        </v-btn>
        <v-btn :disabled="loading" class="secondary" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{ $t("common.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CountrySelect from './CountrySelect.vue';
import {
  MUTATION_PROFILE_LOADED,
} from "@/plugins/store";

export default {
  name: "UserCountryDialog",
  mixins: [],
  components: { CountrySelect },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      dialog: false,
      countryId: undefined
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "700";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
    this.countryId = this.$store.state.profile ? this.$store.state.profile.countryId : undefined
  },
  methods: {
    save() {
      this.loading = true;
      this.$api
        .patchProfile({'countryId': this.countryId})
        .then((res) => {
          this.loading = false;
          this.$store.commit(MUTATION_PROFILE_LOADED, res.data);
          this.close()
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        })
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>